import React from "react";
import "./App.css";
import Landing from "./Pages/Landing";

function App() {
  return (
    <React.Fragment>
      <Landing />
    </React.Fragment>
  );
}

export default App;
